import { createSignal } from '@react-rxjs/utils'
import { RegistrationData, RegistrationResponse, RegistrationUserMetadata } from '../types'

// signal pairing input with response upon success - used by login after registration
export const [registrationSuccess$, setRegistrationSuccess] = createSignal<{
  input: RegistrationData
  isGuestCheckoutEnabled?: boolean
  response: RegistrationResponse<RegistrationUserMetadata>
}>()
